var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswerStatsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.968 23H28.64l9.971 8.82A15.96 15.96 0 0 0 41.968 23z",
    fill: "#fceac5",
    className: "fill-ffc95c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.719 34.252a.998.998 0 0 1-.662-.251l-12.72-11.252A1 1 0 0 1 26 21h17a1 1 0 0 1 1 1c0 4.383-1.609 8.614-4.532 11.915a.996.996 0 0 1-.749.337zM28.64 23l9.971 8.82A15.96 15.96 0 0 0 41.969 23H28.64z",
    fill: "#4c5052",
    className: "fill-004463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 2.031V17h14.969C41.472 8.973 35.027 2.528 27 2.031z",
    fill: "#b3cee0",
    className: "fill-70b6e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19H26a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1c9.925 0 18 8.075 18 18a1 1 0 0 1-1 1zm-16-2h14.969C41.472 8.973 35.027 2.528 27 2.031V17z",
    fill: "#4c5052",
    className: "fill-004463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.353 25.763A1 1 0 0 1 19 25V8C9.626 8 2 15.626 2 25s7.626 17 17 17c4.852 0 9.487-2.095 12.722-5.749L19.353 25.763z",
    fill: "#d0ebbc",
    className: "fill-8ec861"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44C8.523 44 0 35.477 0 25S8.523 6 19 6h1a1 1 0 0 1 1 1v17.537l12.793 10.849a1 1 0 0 1 .103 1.424l-.662.75A19.007 19.007 0 0 1 19 44zm0-36C9.626 8 2 15.626 2 25s7.626 17 17 17c4.852 0 9.487-2.095 12.722-5.749L19.353 25.763A1 1 0 0 1 19 25V8z",
    fill: "#4c5052",
    className: "fill-004463"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 25,
    r: 2,
    fill: "#4c5052",
    className: "fill-004463"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 31,
    r: 2,
    fill: "#4c5052",
    className: "fill-004463"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.999 33a1 1 0 0 1-.799-1.6l6-8a1 1 0 0 1 1.6 1.2l-6 8a.998.998 0 0 1-.801.4z",
    fill: "#4c5052",
    className: "fill-004463"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerStatsIcon);
export default __webpack_public_path__ + "static/media/answerStatsIcon.6428ce07.svg";
export { ForwardRef as ReactComponent };